import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { buildDocumentsDisplayNames } from '../../../../pages/Accounts/DocumentManagement/helpers/documents.helper';

const ImportantDocumentsDeclineConfirmation = ({
  importantDeclinedDocuments,
  accept,
  continueWithoutDeclining,
}) => {
  const declinedDocumentTypes = importantDeclinedDocuments.map(
    (importantDeclinedDocument) => importantDeclinedDocument.documentType,
  );
  const documentsDisplayNames = buildDocumentsDisplayNames(declinedDocumentTypes);

  return (
    <Dialog
      header="WARNING"
      headerClassName="center"
      className="mobile:w-full desktop:w-1/4"
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={importantDeclinedDocuments.length > 0}
      onHide={() => {}}
      position="center"
    >
      <p>
        If you decline the updated {documentsDisplayNames}, your corporate GR8PI platform and all its users and data are
        permanently and irrevocably deleted in 90 days after the declined {documentsDisplayNames} enter(s) into force.
        In these 90 days, you and your users can use the platform under the pre-existing {documentsDisplayNames} to
        access pre-existing data only.
      </p>
      <p>
        If you decline the updated {documentsDisplayNames} now but wish to reverse your decision before the platform is
        deleted, you can log in and do so any time. We will remind you several times within the next 90 days about this
        option.
      </p>
      <br />
      <div className="center">
        <Button type="button" label="ACCEPT" className="p-button-primary" onClick={accept} />
        <Button type="button" label="DECIDE LATER" className="p-button-primary" onClick={continueWithoutDeclining} />
      </div>
    </Dialog>
  );
};

export default ImportantDocumentsDeclineConfirmation;
